import * as angular from "angular";
import * as _ from "lodash";
import { Colors } from "../../shared/config/constant.module";

import { BroadcastMessages, UIInputServiceBroadcastMessages } from './../../shared/config/constant.module';
import { apsEnums } from "../../shared/dto/aps.enums";
import textInputTemplate from "./templates/textInput.tpl.html";
import DateUtilityService from "./dateutility.service";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";

let requires = ['mm.foundation'];

export interface UITextInputService {
  openTextInputModal(
    subject: string,
    headerText: string,
    placeHolderText: string,
    returnItem: any,
    broadcastMessages: UIInputServiceBroadcastMessages,
    minLength: number,
    maxLength: number): angular.IPromise<boolean>;
}

export interface TextInputDialogCtrl {
  save();
  cancel();
}

export interface TextInputDialogData {
  subject: string;
  headerText: string;
  placeHolderText: string;
  returnItem: any;
  broadcastMessages: UIInputServiceBroadcastMessages;
  minLength: number;
  maxLength: number;
}

class UITextInputDialogCtrl implements TextInputDialogCtrl {
  private $modalInstance: mm.foundation.modalInstance;
  public scheduledOn: Date;
  public subject: string;
  public headerText: string;
  public placeHolderText: string;
  private returnItem: any;
  private $rootScope: angular.IRootScopeService;
  private userInput: string;
  private broadcastMessages: UIInputServiceBroadcastMessages;
  private minLength: number;
  private maxLength: number;

  constructor(
    $modalInstance: mm.foundation.modalInstance,
    $rootScope: angular.IRootScopeService,
    data: TextInputDialogData) {

    this.$modalInstance = $modalInstance;
    this.subject = data.subject;
    this.headerText = data.headerText;
    this.placeHolderText = data.placeHolderText;
    this.returnItem = data.returnItem;
    this.broadcastMessages = data.broadcastMessages;
    this.minLength = data.minLength;
    this.maxLength = data.maxLength;

    this.$rootScope = $rootScope;

    this.$modalInstance.result.catch((ex) => {
      this.cancel();
    });
  }

  broadcastMessage(messageTitle, options) {
    this.$rootScope.$emit(messageTitle, options);
  }

  save(): void {
    this.$modalInstance.close(false);
    this.broadcastMessage(this.broadcastMessages.submit, { returnItem: this.returnItem, userInput: this.userInput });
  }

  cancel(): void {
    this.$modalInstance.close(false);
    this.broadcastMessage(this.broadcastMessages.cancel, { returnItem: this.returnItem });
  }

  formatTime(time: Date, timeZoneId: string): string {
    return DateUtilityService.formatTime(time, timeZoneId);
  }
}

class UITextInputSvc implements UITextInputService {
  private $window: angular.IWindowService;
  private $modal: mm.foundation.modal;

  constructor($window: angular.IWindowService, $modal: mm.foundation.modal) {
    this.$window = $window;
    this.$modal = $modal;
  }

  openTextInputModal(
    subject: string,
    headerText: string,
    placeHolderText: string,
    returnItem: any,
    broadcastMessages: UIInputServiceBroadcastMessages,
    minLength: number,
    maxLength: number) {

    let modalConfirmation =
      this.$modal.open({
        template: textInputTemplate,
        controller: 'uiTextInputDialogCtrl as vm',
        resolve: {
          data: (): TextInputDialogData => ({
            subject: subject,
            headerText: headerText,
            placeHolderText: placeHolderText,
            returnItem: returnItem,
            broadcastMessages: broadcastMessages,
            minLength: minLength,
            maxLength: maxLength
          })
        }
      });

    return modalConfirmation.result;
  }
}

export default angular
  .module('ui-text-input', ['mm.foundation'])
  .service('uiTextInputService', UITextInputSvc)
  .controller('uiTextInputDialogCtrl', UITextInputDialogCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/utility/uiTextInput.service.ts